var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLibraryBroadcast = function SvgLibraryBroadcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "library_broadcast_svg2__a",
    x1: 185.3,
    x2: 78.1,
    y1: 27.3,
    y2: 203.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_broadcast_svg2__a",
    id: "library_broadcast_svg2__b",
    x1: 128.8,
    x2: 21.7,
    y1: -7,
    y2: 169.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_broadcast_svg2__a",
    id: "library_broadcast_svg2__c",
    x1: 153.7,
    x2: 46.5,
    y1: 8.1,
    y2: 184.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_broadcast_svg2__a",
    id: "library_broadcast_svg2__d",
    x1: 152.2,
    x2: 45.1,
    y1: 7.2,
    y2: 183.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_broadcast_svg2__a",
    id: "library_broadcast_svg2__e",
    x1: 152.3,
    x2: 45.1,
    y1: 7.3,
    y2: 183.7
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "09-Broadcast"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m138.8 175.5 3.8 10 3.8 10c.2.5.3 1.1.2 1.6 0 .5-.3 1.1-.6 1.5s-.7.8-1.2 1.1-1 .4-1.5.4H56.7c-.5 0-1.1-.1-1.5-.4s-.9-.6-1.2-1.1q-.45-.75-.6-1.5c0-.5 0-1.1.2-1.6l18.9-49.4 18.9-49.4c-1.5-1.3-2.6-2.8-3.4-4.5s-1.2-3.6-1.3-5.5c0-3.7 1.5-7 3.9-9.4s5.7-3.9 9.4-3.9 7 1.5 9.4 3.9 3.9 5.7 3.9 9.4c0 1.9-.5 3.8-1.3 5.5s-2 3.2-3.4 4.5l12.5 32.7 12.5 32.7c.3.9.3 1.8 0 2.5s-1 1.4-1.8 1.8c-.2 0-.4.1-.6.2s-.4 0-.6 0c-.7 0-1.3-.2-1.9-.6s-1-.9-1.2-1.5l-1.8-4.7-1.8-4.7-9 6.1-9 6.1 15.3 10.3 15.3 10.3-1.9-5-1.9-5v-.4c-.3-.9-.2-1.8.2-2.5.4-.8 1.1-1.4 2-1.6.9-.3 1.8-.2 2.5.2s1.4 1.1 1.6 2Zm-6.3 17.8-16.2-11-16.2-11-16.2 11-16.2 11h64.9Zm-56.4-38.2-6.3 16.4-6.3 16.4 15.2-10.3 15.2-10.3-9-6.1-9-6.1Zm23.9 8.2 10-6.8 10-6.8-10-8.6-10-8.6-10 8.6-10 8.6 10 6.8zM82.3 139l6.3-5.4 6.3-5.4-3.2-2.7-3.2-2.7-3.1 8.1zm22.8-10.8 6.3 5.4 6.3 5.4-3.1-8.1-3.1-8.1-3.2 2.7zM100 80c-1.8 0-3.5.7-4.7 2-1.2 1.2-2 2.9-2 4.7s.7 3.5 2 4.7 2.9 2 4.7 2 3.5-.7 4.7-2c1.2-1.2 2-2.9 2-4.7s-.7-3.5-2-4.7c-1.2-1.2-2.9-2-4.7-2m0 20h-1.4c-.5 0-.9-.1-1.3-.2l-3.1 8.1-3.1 8.1 4.5 3.8 4.5 3.8 4.5-3.8 4.5-3.8-3.1-8.2-3.1-8.2c-.4 0-.9.2-1.3.2h-1.4Z",
    style: {
      fill: "url(#library_broadcast_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7 69.8c.8.5 1.2 1.3 1.4 2.1s0 1.7-.5 2.5c-3.6 5.2-5.5 11.2-5.8 17.3s1.1 12.2 4.2 17.8c.4.8.5 1.7.3 2.5s-.8 1.6-1.6 2c-.2.1-.5.2-.8.3s-.6.1-.8.1c-.6 0-1.2-.2-1.7-.5q-.75-.45-1.2-1.2c-3.7-6.6-5.4-14-5-21.4.3-7.3 2.7-14.5 7-20.8.5-.8 1.3-1.2 2.1-1.4s1.7 0 2.5.5Z",
    style: {
      strokeWidth: 0,
      fill: "url(#library_broadcast_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4 114c-.8-.5-1.3-1.2-1.6-2s-.1-1.7.3-2.5c3.1-5.5 4.4-11.7 4.1-17.8s-2.2-12.1-5.8-17.3c-5.2-7.6-13-12.3-21.4-13.9s-17.4 0-25 5.3c-.7.5-1.6.6-2.3.4s-1.5-.6-2-1.2c-.6-.7-.8-1.6-.7-2.5.1-.8.5-1.7 1.3-2.2 6.3-4.3 13.4-6.6 20.7-7s14.7 1.3 21.3 5c9.7 5.4 16.2 14.1 19.1 24 2.8 9.8 1.9 20.8-3.5 30.4q-.45.75-1.2 1.2c-.75.45-1.1.5-1.7.5-.3 0-.6 0-.8-.1s-.5-.2-.8-.3",
    style: {
      strokeWidth: 0,
      fill: "url(#library_broadcast_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 143.1c-.5 0-.9 0-1.4-.3s-.8-.5-1.1-.8q-.9-1.05-.9-2.4c0-.9.4-1.7 1.1-2.3 6.2-5.6 11-12.5 14.3-19.9 3.3-7.5 5-15.7 5-24 0-16.6-6.7-31.6-17.6-42.4-10.9-10.9-25.8-17.6-42.4-17.6S68.4 40.1 57.6 51C46.7 61.9 40 76.9 40 93.4c0 8.4 1.7 16.5 5 24s8.1 14.3 14.3 19.9c.7.6 1 1.5 1.1 2.3s-.3 1.7-.9 2.4-1.5 1-2.3 1.1-1.7-.3-2.4-.9c-.6-.6-1.3-1.2-1.9-1.8s-1.2-1.2-1.8-1.9C38.6 125 32.8 107.7 33.4 90.6c.7-17 7.8-33.8 21.3-46.3S85.5 26 102.6 26.6c17 .7 33.8 7.8 46.3 21.3s18.3 30.8 17.7 47.9c-.7 17-7.8 33.8-21.3 46.3-.3.3-.7.5-1 .7s-.8.2-1.2.2Z",
    style: {
      strokeWidth: 0,
      fill: "url(#library_broadcast_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 0c14.9 0 29.4 3.6 42.3 10.1 12.9 6.6 24.3 16.2 33.1 28.2 15.2 20.8 20.5 45.8 16.8 69.4s-16.4 45.8-37.2 61c-.3.2-.6.4-.9.5s-.7.2-1 .2c-.5 0-1.1-.1-1.5-.4s-.9-.6-1.2-1c-.5-.7-.7-1.6-.6-2.5s.6-1.6 1.3-2.2c3.6-2.6 7-5.6 10.2-8.7q4.8-4.8 8.7-10.2c14.1-19.3 19-42.6 15.6-64.5S170.4 37.4 151 23.3c-19.3-14.1-42.6-19-64.5-15.6S44 22.9 29.9 42.3c-14.1 19.3-19 42.6-15.6 64.5s15.2 42.5 34.6 56.6c.7.5 1.2 1.3 1.3 2.2.1.8 0 1.7-.6 2.5-.5.7-1.3 1.2-2.2 1.3s-1.7 0-2.5-.6c-12-8.8-21.6-20.2-28.2-33.1S6.6 108.3 6.6 93.4c0-25.8 10.4-49.1 27.3-66C50.9 10.5 74.2 0 100 0",
    style: {
      strokeWidth: 0,
      fill: "url(#library_broadcast_svg2__e)"
    }
  })));
};
export default SvgLibraryBroadcast;